export default __webpack_public_path__ + "static/media/what-to-expect.bf60cf4b.pdf";